import { trackPageLoad } from './aep_analytics_util.js';
import { loadFonts, init as initDynamicKit } from './DynamicKit.js';
import { init as initIms } from './imslib.js';
import { enableConsentCheck } from './adobe_privacy.js';
import { registerEventHandlers as registerPageLoadDialogEventHandlers } from '../components/mixins/PageLoadDialog.ts';
import SitewideHeaderController from '../controllers/sitewide_header.js';
import { initSUSILight } from './susi_light_util.js';
import UrlService from './url_service.js';

export function setupGlobals() {
  UrlService.removeSearchParam('logged_out');

  initDynamicKit();
  loadFonts();
  initIms();
  enableConsentCheck();
  const sitewideHeaderController = new SitewideHeaderController();
  sitewideHeaderController.init();
  initSUSILight();

  registerPageLoadDialogEventHandlers();
  trackPageLoad();
}
